<template>
    <div v-if="branchMethods" class="payment-methods">
        <div class="tabs is-toggle">
            <ul>
                <li v-for="type of Object.keys(branchMethods)" :class="[{ 'is-active': type === selectedTab }]" @click="selectedTab = type">
                    <a>{{ type }}</a>
                </li>
            </ul>
        </div>

        <div v-if="selectedTab === 'withdrawal'" class="columns">
            <div class="column is-1">
                <label>Currency</label>
                <div class="select is-small">
                    <select v-model="pinMethod.currency">
                        <option v-for="currency of currencies" :value="currency.id">{{ currency.id }}</option>
                    </select>
                </div>
            </div>
            <div class="column is-1">
                <label>
                    Min Amount:
                    <currency-input :value="pinMethod.amountMin" :currency="pinMethod.currency || ''" :set="value => pinMethod.amountMin = value" class="input is-small" />
                </label>
            </div>
            <div class="column is-1">
                <label>
                    Max Amount:
                    <currency-input :value="pinMethod.amountMax" :currency="pinMethod.currency || ''" :set="value => pinMethod.amountMax = value" class="input is-small" />
                </label>
            </div>
            <div class="column is-1" style="margin:auto auto 0 0;">
                <button class="button is-small is-primary" @click="addPinMethod();">Add Pin Method</button>
            </div>
        </div>

        <table v-if="selectedTab" class="table is-striped">
            <thead>
                <tr>
                    <th class="has-text-centered">Name</th>
                    <th class="has-text-centered">Currency</th>
                    <th class="has-text-centered">Min</th>
                    <th class="has-text-centered">Max</th>
                    <th class="has-text-centered">
                        Tax<br />
                        Ext Min | Min | Value | Max | Ext Max
                    </th>
                    <th class="has-text-centered">Description</th>
                    <th class="has-text-centered">Enabled</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="method of branchMethods[selectedTab]">
                    <td>{{ method.name }}</td>
                    <td class="has-text-centered">
                        <div v-if="method.name === 'Pin'" class="select is-small">
                            <select v-model="method.currency">
                                <option v-for="currency of currencies" :value="currency.id">{{ currency.id }}</option>
                            </select>
                        </div>
                        <template v-else>
                            {{ method.currency }}
                        </template>
                    </td>
                    <td>
                        <template v-if="method.currency">
                            <div class="field has-addons">
                                <p class="control">
                                    <a class="button is-static is-small">{{ getDecimal(method.externalAmountMin, method.currency) }}</a>
                                </p>
                                <p class="control">
                                    <currency-input :value="method.amountMin" :currency="method.currency" :set="value => method.amountMin = value" class="input is-small" />
                                </p>
                            </div>
                        </template>
                        <input v-else class="input is-small" disabled />
                    </td>
                    <td>
                        <template v-if="method.currency">
                            <div class="field has-addons">
                                <p class="control">
                                    <currency-input :value="method.amountMax" :currency="method.currency" :set="value => method.amountMax = value" class="input is-small" />
                                </p>
                                <p class="control">
                                    <a class="button is-static is-small">{{ getDecimal(method.externalAmountMax, method.currency) }}</a>
                                </p>
                            </div>
                        </template>
                        <input v-else class="input is-small" disabled />
                    </td>
                    <td>
                        <template v-if="method.currency">
                            <div class="field has-addons taxes">
                                <p class="control">
                                    <a class="button is-static is-small">{{ method.externalTaxMin }}</a>
                                </p>
                                <p class="control">
                                    <input v-model="method.taxMin" type="number" class="input is-small" size="5" />
                                </p>
                                <p class="control">
                                    <input v-model="method.tax" type="number" class="input is-small" size="5" />
                                </p>
                                <p class="control">
                                    <input v-model="method.taxMax" type="number" class="input is-small" size="5" />
                                </p>
                                <p class="control">
                                    <a class="button is-static is-small">{{ method.externalTaxMax }}</a>
                                </p>
                            </div>
                        </template>
                        <input v-else class="input is-small" disabled />
                    </td>
                    <td>
                        {{ method.description }}
                    </td>
                    <td class="has-text-centered">
                        <input v-model="method.enabled" type="checkbox" />
                    </td>
                    <td class="has-text-centered">
                        <button class="button is-small" @click="removePinMethod(method);">Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="field">
            <div class="control">
                <button class="button is-success" @click="saveAsync();">Save</button>
            </div>
        </div>
    </div>
</template>
<script>
    import branchService from "../../../../../../services/branch.service";
    import currencyService from "../../../../../../services/currency.service";
    import state from "../../../../../../state";
    import currencyInput from "../../../../../common/currency-input.vue";

    const pinMethodName = "Pin";
    const createPin = () => ({ name: pinMethodName, currency: null, amountMin: 0, amountMax: 0, enabled: true });
    const compare = (method1, method2) => method1.methodId === method2.methodId;

    export default {
        name: "methods",
        components: { currencyInput },
        data: () => ({
            client: null,
            branch: null,
            branchMethods: null,
            pinMethod: createPin(),
            selectedTab: "deposit"
        }),
        computed: {
            clientId: function() {
                return Number(this.$route.params.clientId);
            },
            branchName: function() {
                return this.$route.params.branch;
            },
            currencies: function() {
                return state.currencies.get();
            }
        },
        mounted() {
            this.loadBranchAsync();
        },
        methods: {
            async loadBranchAsync() {
                this.branch = await branchService.get(this.clientId, this.branchName);
                this.branch.settings.paymentSystem = await branchService.getPaymentSettings(this.clientId, this.branchName);
                this.branchMethods = Object.keys(this.branch.settings.paymentSystem).reduce((obj, key) => (obj[key] = this.branch.settings.paymentSystem[key].methods) && obj, {});
            },
            addPinMethod() {
                if (!this.pinMethod.currency) {
                    return;
                }

                const branchMethods = this.branchMethods[this.selectedTab];
                if (branchMethods.some(item => item.name === this.pinMethod.name && item.currency === this.pinMethod.currency)) {
                    return;
                }

                branchMethods.push(Object.assign({ name: pinMethodName }, this.pinMethod));
                this.pinMethod = createPin();
            },
            removePinMethod(method) {
                const branchMethods = this.branchMethods[this.selectedTab];
                let index = branchMethods.length;
                while (index--) {
                    (branchMethods[index] === method) && branchMethods.splice(index, 1);
                }
            },
            getDecimal(value, currency) {
                return currencyService.fromSource(value || 0, currency);
            },
            async saveAsync() {
                await branchService.saveSettings(this.clientId, this.branch.branch, this.branch.settings);
                this.branch = await branchService.update(this.branch);
            }
        }
    }
</script>

<style scoped>
    table th {
        vertical-align: middle;
    }

    .taxes input[type=number] {
        width: 80px;
    }
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/payments/methods.vue